// `[HTTP_HANDLED_RESPONSE]` / docs/rules/error-handling.md: 402 is the one intercepted status that
// REJECTS rather than resolving with `_handled`, so a caller's `catch` DOES run — but the interceptor
// has already dispatched the paywall snackbar/popup. A caller that then calls its own `showError`
// shows the user two notifications for one failure. Use this to reset loading state and stay silent.
//
// **402 only, deliberately.** 401/403 on an auth or `/v1/teams` URL also reject, but there the
// interceptor stays silent ON PURPOSE so the page can render inline UX — suppressing those would
// swallow a real error. Everything else the interceptor notifies about RESOLVES with `_handled`, so
// `res?._handled` is the check for those, not this.
//
// This lives in its own module rather than in `utils/reasonError`, where it started life: that file
// imports `i18n` at module scope for `reasonCodeText`, so importing this pure predicate from it
// dragged the whole i18n bootstrap into every consumer — which broke two `useDownloadLogic` suites
// whose `react-i18next` mock omits `initReactI18next`. A guard that catches double-dispatch has to be
// importable from anywhere; it had zero consumers until this was untangled. REF-6437 follow-up.
export const isPaywallRejection = (err: any): boolean => err?.response?.status === 402;
